import "./styles.css";
import Navbar from "./components/Navbar/Navbar";
import "./components/Navbar/navbar.css";
import "./components/Thumbnail/thumbnail.css";
import "./components/Footer/footer.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import About from "./components/About/About";
import "./components/About/about.css";
import Home from "./components/Home/Home";
import Food from "./components/TWStreetFood/Food";
import Nostalgia from "./components/Nostalgia/Nostalgia";
import Cat from "./components/Cat/Cat";
import Learning from "./components/Learning/Learning";
import Golf from "./components/Golf/Golf";
import Strava from "./components/Strava/Strava";
export default function App() {
  return (
    <div>
      <Router>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/food" element={<Food />} />
          <Route exact path="/nostalgia" element={<Nostalgia />} />
          <Route exact path="/cat" element={<Cat />} />
          <Route exact path="/learning" element={<Learning />} />
          <Route exact path="/golf" element={<Golf />} />
          <Route exact path="/strava" element={<Strava />} />
        </Routes>
      </Router>
    </div>
  );
}
